import {
  DatePicker,
  DayOfWeek,
  Dropdown,
  IDropdownOption,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
} from "office-ui-fabric-react";
import React from "react";
import { IDataCenter, ISlaMatrixAlert } from "../../vm";
import { ToastContext } from "../common/ToastProvider";
import moment from "moment";
import { getSlaMatrixAlert } from "../../services/dashboard/DashboardService";
import { childrenGap } from "../common/Constants";
import ReportStatusCard from "./ReportStatusCard";
import { useHistory } from "react-router";
import { Loading } from "../../services/Loading";

export interface SlaMatrixDashboardProps {
  datacenters: IDataCenter[];
}
const wrapperStyles = {
  // width: "100%",
  // maxWidth: 980,
  margin: "0 auto",
};

const SlaMatrixDashboard: React.FC<SlaMatrixDashboardProps> = ({
  datacenters,
}) => {
  // custom hooks
  const history = useHistory();
  const { showToast } = React.useContext(ToastContext);

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    slaMatrixAlert: {
      temp: 0,
      rh: 0,
      uptime: 0,
    },
    searchObj: {
      date: new Date(),
      datacenterIds: datacenters.length > 0 ? [datacenters[0]?._id] : [],
    },
    datacenterOptions: [],
    selectedDatacenter: datacenters.length > 0 ? datacenters[0]?._id : "",
    showCallender: false,
  } as {
    isLoading: boolean;
    slaMatrixAlert: ISlaMatrixAlert;
    searchObj: {
      date: Date | string;
      datacenterIds: string[];
    };
    datacenterOptions: IDropdownOption[];
    selectedDatacenter: string;
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getSlaMatrixAlerts();
    };
    asyncFunc();
  }, []);

  const getSlaMatrixAlerts = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
    }
    setState({ ...localState, isLoading: true });
    let searchObj = { ...localState.searchObj };
    searchObj.date = moment(searchObj.date).format("YYYY-MM-DD");

    let result = await getSlaMatrixAlert(searchObj);
    if (result?.success) {
      let datacenterOptions: IDropdownOption[] = [];
      if (datacenters.length > 0) {
        datacenters.forEach((d) => {
          datacenterOptions.push({
            key: d._id as string,
            text: d.name,
          });
        });
      }

      setState({
        ...localState,
        slaMatrixAlert: result.data,
        datacenterOptions,
      });
    } else {
      setState({ ...localState, isLoading: false });
      showToast(
        result?.message || "Error while getting sla matrix alert",
        "error"
      );
    }
  };

  const viewSlaMatrixAlertDetails = (type: string) => {
    history.push(
      `/sla-matrix-alert-details?date=${moment(state.searchObj.date).format(
        "YYYY-MM-DD"
      )}&datacenterId=${state.selectedDatacenter}&type=${type}`
    );
  };

  return (
    <React.Fragment>
      {/* {state.isLoading && <Loading />} */}
      <div style={wrapperStyles}>
        <div className="ms-Grid p-0">
          <div className="ms-Grid-row ms-motion-scaleDownIn status-count-card overflow ml-0 mr-0">
            {state.isLoading && (
              <div className="custom-card spinner-center">
                <Spinner
                  size={SpinnerSize.large}
                // label="Loading"
                // labelPosition="bottom"
                />
              </div>
            )}
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12">
              <Stack
                horizontal
                horizontalAlign="space-between"
                wrap
                tokens={childrenGap}
              >
                <Stack.Item>
                  <Text className="dashboard-card-title">SLA Breach</Text>
                </Stack.Item>
                <Stack.Item>
                  <Stack horizontal wrap tokens={childrenGap}>
                    <Stack.Item>
                      <Dropdown
                        selectedKey={state.selectedDatacenter}
                        styles={{ dropdown: { width: 200 } }}
                        options={state.datacenterOptions}
                        onChange={async (e, v: IDropdownOption | undefined) => {
                          if (v) {
                            let datacenterIds: string[] = [];
                            datacenterIds.push(v.key as string);
                            let obj = {
                              ...state,
                              selectedDatacenter: v.key as string,
                              searchObj: {
                                ...state.searchObj,
                                datacenterIds,
                              },
                            };
                            // setState();
                            await getSlaMatrixAlerts(obj as any);
                          }
                        }}
                      />
                    </Stack.Item>
                    <Stack.Item>
                      <DatePicker
                        firstDayOfWeek={DayOfWeek.Sunday}
                        showMonthPickerAsOverlay={true}
                        value={new Date(state.searchObj.date)}
                        showGoToToday={false}
                        onSelectDate={async (date: Date | null | undefined) => {
                          let obj = {
                            ...state,
                            searchObj: {
                              ...state.searchObj,
                              date: date as Date,
                            },
                          };
                          await getSlaMatrixAlerts(obj as any);
                        }}
                        styles={{ root: { width: 200 } }}
                      />
                    </Stack.Item>
                  </Stack>
                </Stack.Item>
              </Stack>
              <hr />
              <div className="ms-Grid-row">
                <div className="ms-Grid-col pt-0 ms-sm12 ms-md12 ms-lg12">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6 ms-xl6">
                      <div onClick={() => viewSlaMatrixAlertDetails("temp")}>
                        <ReportStatusCard
                          status={"temp"}
                          count={state.slaMatrixAlert.temp}
                          isReportStatus={false}
                          isMomStatus={false}
                          isSlaMatrix={true}
                        />
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6 ms-xl6">
                      <div onClick={() => viewSlaMatrixAlertDetails("rh")}>
                        <ReportStatusCard
                          status={"rh"}
                          count={state.slaMatrixAlert.rh}
                          isReportStatus={false}
                          isMomStatus={false}
                          isSlaMatrix={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SlaMatrixDashboard;
